
import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule, UntypedFormControl } from '@angular/forms';
import { RouterLink, RouterModule } from '@angular/router';
import { MatIconModule } from '@angular/material/icon';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatSelectModule } from '@angular/material/select';
import { MatOptionModule } from '@angular/material/core';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { NgxPaginationModule } from 'ngx-pagination';
import { NgSelectModule } from '@ng-select/ng-select';
import { HelpsectionComponent } from '../helpsection/helpsection.component';
import { SuppliertabComponent } from '../suppliertab/suppliertab.component';
import {  CommonService } from '../_service/common.service';
import { appConfig } from '../app.config';

const TWO = 2;
const THREE = 3;
const THREE_THOUSAND_MS = 3000;

@Component({
    selector: 'app-supplier',
    templateUrl: './supplier.component.html',
    standalone: true,
    imports: [
        CommonModule, FormsModule, ReactiveFormsModule, RouterLink, RouterModule,
        MatIconModule, MatFormFieldModule, MatInputModule, MatAutocompleteModule,
        MatSelectModule, MatOptionModule, MatTooltipModule, MatProgressSpinnerModule,
        NgxPaginationModule, NgSelectModule, HelpsectionComponent, SuppliertabComponent
    ]
})
export class SupplierComponent implements OnInit {
  title = 'Renault Digital frontend';
  myControl = new UntypedFormControl();
  loading:boolean = false;  
  Config:any;
  public identifierTypes:any = [];
  public businessEntityIdentifierTypes:any = [];
  public identifierValue:any = [];
  public identifierName:any = [];
  public identifierValueModify:any = [];
  public identifierValueLists:any = [];
  public identifierLists:any = [];
  public supplierDataLists:any = [];
  public suppliervalDropDown:any = [];
  public supplierNameDropDown:any = [];
  info:any;
  selectedValue: string = '';
  params: string = '';
  identifierTypeModel: string = 'business-entities';
  identifierValueModel: string = '';
  supplierNameModel: string = '';
  paramSplited: string = '';
  listFlag: boolean = false;
  public customLoadingTemplate : any;
  constructor(private apiService: CommonService) {
       this.Config = appConfig; 
   }

   ngOnInit() {
   
   this.getCompanyIdentifierTypes();
   this.getBusinessEntityIdentifierTypes();
   this.getIdentifierValue('business-entities');
   this.getIdentifierName('business-entities');

     // this.identifierTypes = '{"company-identifier-types":[{"name":"SCOPP MDM CODE","description":"<p>SCOPP MDM code<\/p>","row_id":"2","type":"OTH"},{"name":"SIREN","description":"","row_id":"3","type":"OTH"},{"name":"VAT","description":"<p>VAT code<\/p>","row_id":"8","type":"TAX"}]}';
  }

  getCompanyIdentifierTypes(){
  //  this.loading = true;
      this.apiService.get(`${this.Config.ApiSupplierUrl}company-identifier-types`).subscribe((data:any) => {
        if(data && data!=null){
          this.identifierTypes = data['company-identifier-types'];
        }
      //  console.info('data',  data['company-identifier-types']);
      },error=>{
        console.info('data_error', error); 
    });   
  }
  getBusinessEntityIdentifierTypes(){
  //  this.loading = true;
      this.apiService.get(`${this.Config.ApiSupplierUrl}business-entity-identifier-types`).subscribe((data:any) => {
        if(data && data!=null){
          this.businessEntityIdentifierTypes = data['business-entity-identifier-types'];
        }
        //console.info('data',  data['business-entity-identifier-types']);
      },error=>{
        console.info('data_error', error); 
    });   
  }

  selectChangeHandler (event: any) {
    //update the ui
    this.listFlag = false;
    this.selectedValue = event.target.value;
    var splitted = this.selectedValue.split("$");   
    //if(splitted[0] == 'business-entities') {
      //this.identifierValueModel = '';
      // }
      this.identifierValueModel = '';
      this.supplierNameModel = '';
      this.getIdentifierValue(splitted[0]);
      //this.getIdentifierName(splitted[0]);
      


     // this.getIdentifierName(splitted[0]);

  }
  getIdentifierName(params){
    this.loading = true;

    let paramSplited = params.split("/");
    let params1 = '';
    let params2 = '';
    if(paramSplited[1] == undefined) {
      params1 = paramSplited[0];
      params2 = paramSplited[0];;
    }else {
      params1 = paramSplited[0];
      params2 = params;
    }
   // console.info(paramSplited[0]);
   
   // this.params = params;   
  // console.info('====>'+params1)
    this.apiService.get(this.Config.ApiSupplierUrl+params2).subscribe((data:any) => {
      if(data && data!=null){        
       
      this.identifierValueLists = [];
       if(data[params1] != undefined) {
        //console.info(data);
        this.identifierName = data[params1];
        this.identifierValueLists = data[params1];
        for(let i=0; i<this.identifierName.length; i++) {
            this.identifierName[i]["allianceIdentifierSelect"] = this.identifierName[i]['companyAllianceIdentifier'];
            this.identifierName[i]["allianceIdentifierLegalname"] = this.identifierName[i]['companyLegalName'];
            this.identifierName[i]["identifier"] = this.identifierName[i]['identifier'];
            this.supplierNameDropDown = this.identifierName;
        }
        this.loading = false;
      }else {
        this.loading = true;
        if(data != '') {
         //console.info(paramSplited[0]);
        // console.info("=====>", data);
         this.identifierValueLists[0] =data; 
          this.identifierValueLists[0]["allianceIdentifierSelect"] = data['companyAllianceIdentifier'];
          this.identifierValueLists[0]["allianceIdentifierLegalname"] = data['companyLegalName'];
          if(this.listFlag == true) { this.identifierValueLists[0]["bvdid"] = [];
         // console.info("=====>", data['identifier']);
           this.getBVDid(data['identifier'], "BVD ID",0,1); 
           this.loading = false;}
        
      }
      }
     // this.identifierValueList = this.identifierValue;
      //console.info(this.identifierValueList);
      }
     
    },error=>{
      console.info('data_error', error); 
  });   
  }

  getIdentyfyVal(subparams, columnname, columnvalue,_indexi,companyAllianceIdentifier,companyLegalName) {

    this.identifierLists = {};
    this.suppliervalDropDown = [];
    this.apiService.get(this.Config.ApiSupplierUrl+subparams).subscribe((data:any) => {
     //console.info("mmmmanis", data);
      if(data && data!=null){ 
       var j=0;      
       //this.suppliervalDropDown = data;
      // console.info("columnanme=>",columnname);
      for(let i=0; i<data[subparams].length; i++) {
       // console.info("columnvalue=>",columnvalue)
      // console.info("data[subparams][i][columnname]", data[subparams][i][columnname])
       if(data[subparams][i][columnname] == columnvalue) {
        //console.info("columnvalue=>",columnvalue)
        //console.info('inserted');
        let rowobj2 = Object.assign({},  data[subparams][i]);
        //console.info(data[subparams][i]['row_id']);
        rowobj2.companyAllianceIdentifier = data[subparams][i][companyAllianceIdentifier];
        rowobj2.companyLegalName = data[subparams][i][companyLegalName];
        rowobj2.row_id = data[subparams][i]['row_id'];
        this.suppliervalDropDown.push(rowobj2);
       

       }
      }
     
      const result = [];
      if(this.suppliervalDropDown.length>0) {
      const map = new Map();
      for (const item of this.suppliervalDropDown) {
          if(!map.has(item.companyAllianceIdentifier)){
              map.set(item.companyAllianceIdentifier, true);    // set any value to Map
              result.push({
                companyAllianceIdentifier: item.companyAllianceIdentifier,
                companyLegalName: item.companyLegalName,
                allianceIdentifierSelect: item.companyAllianceIdentifier,
                row_id: item.row_id
              });
          }
      }
    }
      this.suppliervalDropDown = [];
      if(result.length<=0) {
        //console.info(1);
        this.suppliervalDropDown = [];
      }else {
        //console.info(2);
        this.suppliervalDropDown = result;
      }
      //console.info('inserted===>', this.suppliervalDropDown);
     // console.info("this.suppliervalDropDown=>",this.suppliervalDropDown);
      }else {
        this.suppliervalDropDown = [];
      }    
    },error=>{
      console.info('data_error', error); 
  });   

  }

  getIdentifierValue(params){
    this.loading = true;
    this.params = params; 
    this.supplierDataLists = [];
      this.apiService.get(this.Config.ApiSupplierUrl+params).subscribe((data:any) => {
        if(data && data!=null){
          let paramSplited = params.split("/");
          let typeSplitted = this.identifierTypeModel.split("$$");   
          //console.info(data);         
        //  console.info(data[params]);

        //if(paramSplited[0] == 'business-entities') {
          
       // }

        this.identifierValueLists = [];
         if(data[paramSplited[0]] != undefined) {
           
          this.identifierValue = data[paramSplited[0]];
          this.identifierValueLists = data[paramSplited[0]];
          for(var i=0; i<this.identifierValue.length; i++) {
            if(paramSplited[0] == 'business-entities') {
            
              this.identifierValue[i]["allianceIdentifierSelect"] = this.identifierValue[i]['companyAllianceIdentifier'];
              this.identifierValue[i]["allianceIdentifierLegalname"] = this.identifierValue[i]['companyLegalName'];
             
              this.suppliervalDropDown = this.identifierValue;
            //  this.getIdentyfyVal('business-entity-identifiers', this.identifierValue[i]['identifier'], "BVD ID",i,this.identifierValue[i]['companyAllianceIdentifier'],this.identifierValue[i]['companyLegalName']) ; 

              this.identifierValueLists[i]["allianceIdentifierSelect"] = this.identifierValue[i]['companyAllianceIdentifier'];
              this.identifierValueLists[i]["allianceIdentifierLegalname"] = this.identifierValue[i]['companyLegalName'];
             // if(this.listFlag == true) this.identifierValueLists[i]["bvdid"] = this.getBVDid(this.identifierValue[i]['identifier'], "BVD ID",i);

            // if(this.listFlag == true) {  this.identifierValueLists[0]["bvdid"] = [];
            // this.getBVDid(this.identifierValue[i]['identifier'], "BVD ID",i,1) ; }
             
            }else  if(paramSplited[0] == 'company-identifiers') {
              //console.info("commings1....");

              this.identifierValue[i]["allianceIdentifierSelect"] = this.identifierValue[i]['companyAllianceIdentifier'];
              this.identifierValue[i]["allianceIdentifierLegalname"] = this.identifierValue[i]['value'];
              //console.info("commings1....", this.identifierValue);
             
             // this.identifierValueLists[i]["allianceIdentifierSelect"] = this.identifierValue[i]['companyAllianceIdentifier'];
             // this.identifierValueLists[i]["allianceIdentifierLegalname"] = this.identifierValue[i]['value'];
             
              this.getIdentyfyVal('company-identifiers', 'companyIdentifierTypeName', typeSplitted[2],i,'companyAllianceIdentifier','value'); 

            //  if(this.listFlag == true) {  
            // this.getBusinessEntities(this.identifierValue[i]['companyAllianceIdentifier'], i);
             //this.identifierValueLists[i]["bvdid"] = [];
             //console.info("testings=>", this.identifierValueLists[i]["allianceIdentifierSelect"]);
             //this.getBVDid(this.identifierValueLists[i]["allianceIdentifierSelect"], typeSplitted[2],i,2);
            // }

            }else  if(paramSplited[0] == 'business-entity-identifiers') {
              this.identifierValue[i]["allianceIdentifierSelect"] = this.identifierValue[i]['businessEntityAllianceIdentifier'];
              this.identifierValue[i]["allianceIdentifierLegalname"] = this.identifierValue[i]['value'];
              //this.identifierValueLists[i]["allianceIdentifierSelect"] = this.identifierValue[i]['businessEntityAllianceIdentifier'];
              //this.identifierValueLists[i]["allianceIdentifierLegalname"] = this.identifierValue[i]['value'];
              this.getIdentyfyVal('business-entity-identifiers', 'businessEntityIdentifierTypeName', typeSplitted[2],i,'businessEntityAllianceIdentifier','value') ; 
            }
          }
          this.loading = false;
        }else {
         // console.info("======>"+paramSplited[0]);
          if(data != '') {
           //console.info(paramSplited[0]);
           this.loading = true;
           this.identifierValueLists[0] =data; 
           this.identifierValueLists[0]['bvdid'] =''; 
          if(paramSplited[0] == 'business-entities') {
          
            this.identifierValueLists[0]["allianceIdentifierSelect"] = data['companyAllianceIdentifier'];
            this.identifierValueLists[0]["allianceIdentifierLegalname"] = data['companyLegalName'];
            if(this.listFlag == true) { this.identifierValueLists[0]["bvdid"] = [];
             this.getBVDid(data['identifier'], "BVD ID",0,1); 
             this.loading = false;}
          }else  if(paramSplited[0] == 'company-identifiers') {
            //this.identifierValueLists[0]["allianceIdentifierSelect"] = data['companyAllianceIdentifier'];
           // this.identifierValueLists[0]["allianceIdentifierLegalname"] = data['value'];
            
            if(this.listFlag == true) {  
             
             this.getBusinessEntities(data['companyAllianceIdentifier'], 0);
              this.identifierValueLists[0]["bvdid"] = [];              
             // console.info("commings....", this.identifierValueLists);
              //console.info("testings=>", this.identifierValueLists[0]["identifier"]);
            
              setTimeout(() => {
               // console.info("commings....", this.identifierValueLists[0]['identifier']);
                if(this.identifierValueLists[0]['identifier'] != undefined) {              
                  this.getBVDid(this.identifierValueLists[0]['identifier'], typeSplitted[2], 0, TWO);
               }else {
                this.supplierDataLists = [];
               }
               this.loading = false;
              }, THREE_THOUSAND_MS);
            
            // console.info("testings=>", this.supplierDataLists);
              }
            //  return false;
          }else  if(paramSplited[0] == 'business-entity-identifiers') {
           // this.identifierValueLists[0]["allianceIdentifierSelect"] = data['businessEntityAllianceIdentifier'];
          //  this.identifierValueLists[0]["allianceIdentifierLegalname"] = data['value'];
          if(this.listFlag == true) {  
            this.getBusinessEntities(data['businessEntityAllianceIdentifier'], 0);
            this.identifierValueLists[0]["bvdid"] = [];       
            //console.info("mmmmmmmm");       
            //console.info("testings=>", this.identifierValueLists[0]["identifier"]);
            setTimeout(() => {
           if(this.identifierValueLists[0]["identifier"] != undefined) {
              this.getBVDid(this.identifierValueLists[0]["identifier"], typeSplitted[2], 0, TWO);
              
           }else {
            this.supplierDataLists = [];
           }
           this.loading = false;
          }, THREE_THOUSAND_MS);
          // console.info("testings=>", this.supplierDataLists);
            }
          }
        }
        }
        
       
        }
        
      },error=>{
        console.info('data_error', error); 
    });   
    //this.loading = false;
  }
  getBusinessEntities(allianceIdentifier,indexi) {

    this.apiService.get(`${this.Config.ApiSupplierUrl}business-entities`).subscribe((data:any) => {
      // console.info("mmmmanis", data);
       if(data && data!=null){ 
        let j=0;      
           for(let i=0; i<data['business-entities'].length; i++) {
             if(data['business-entities'][i]['companyAllianceIdentifier'] == allianceIdentifier) {
              this.identifierValueLists[indexi]["allianceIdentifierSelect"] = data['business-entities'][i]['companyAllianceIdentifier'];
              this.identifierValueLists[indexi]["allianceIdentifierLegalname"] = data['business-entities'][i]['companyLegalName'];
              this.identifierValueLists[indexi]["identifier"] = data['business-entities'][i]['identifier'];
             }             
           }
           //console.info(this.identifierValueLists[indexi]["bvdid"].length);
           if(this.identifierValueLists[indexi].length<=0) {
            this.identifierValueLists = [];
           }
         //  this.identifierValueLists[indexi]["bvdid"] = Object.assign({}, this.identifierLists);
         // console.info(this.identifierValueLists);
         // console.info(this.identifierValueLists[indexi]);
          // return this.identifierLists;
       }
     //console.info(' this.supplierDataLists',  this.supplierDataLists);
     
     },error=>{
       console.info('data_error', error); 
   });   

  }

  getChangeHandler() {
  //  this.loading = true;
  this.listFlag = true;
  this.supplierDataLists = [];
   var splitted = this.identifierTypeModel.split("$");   
    if(this.identifierValueModel != '' && this.identifierTypeModel != ''  && this.supplierNameModel == '') {
    // console.info(splitted[0], this.identifierValueModel);
      this.getIdentifierValue(`${splitted[0]}/${this.identifierValueModel}`);
    //  this.loading = false;
    }else  if(this.identifierValueModel == '' && this.identifierTypeModel != ''  && this.supplierNameModel != '') {
     //console.info('mais===>'+splitted[0]);
    // console.info(2);
   
        this.getIdentifierName(`business-entities/${this.supplierNameModel}`);
      
    }else {
      this.listFlag = false;
      this.identifierValueLists=[];
    }
    //console.info(this.identifierValueLists);
    //console.info(this.identifierValue);
  }

  resetSelectedFields(resetparam:any) {
    this.loading = true;
    if(resetparam == 'supplierNameModel') this.supplierNameModel = '';
    else if(resetparam == 'identifierValueModel') this.identifierValueModel = '';
    else {  this.supplierNameModel = ''; this.identifierValueModel = '';}
    this.loading = false;
  }
  
  getBVDid(identifier, identifierTypeName,indexi,_flags) {
  //  
  //console.info(identifier, identifierTypeName);
    this.identifierLists = {};
    this.apiService.get(`${this.Config.ApiSupplierUrl}business-entity-identifiers`).subscribe((data:any) => {
     // console.info("mmmmanis", data);
      if(data && data!=null){ 
       let j=0;      
          for(let i=0; i<data['business-entity-identifiers'].length; i++) {
            if(data['business-entity-identifiers'][i]['businessEntityAllianceIdentifier'] == identifier && data['business-entity-identifiers'][i]['businessEntityIdentifierTypeName'] == identifierTypeName) {
                 this.identifierLists[j] = data['business-entity-identifiers'][i]['value'];
                 let rowobj2 = Object.assign({},  this.identifierValueLists[indexi]);
                  rowobj2.bvdid = data['business-entity-identifiers'][i]['value'];
                  this.identifierValueLists[indexi]["bvdid"].push(data['business-entity-identifiers'][i]['value']);
                  this.supplierDataLists.push(rowobj2);
                  j++;
            }
            
          }
        //  console.info(this.identifierValueLists[indexi]);
          if(this.identifierValueLists[indexi] !=undefined && this.identifierValueLists[indexi]["bvdid"].length<=0) {
            this.identifierValueLists[indexi]['bvdid'] = '';
            let rowobj2 = Object.assign({},  this.identifierValueLists[indexi]);
            this.supplierDataLists.push(rowobj2);
          }else if(this.identifierValueLists[indexi] ==undefined) {
              this.supplierDataLists = this.identifierValueLists;
          }
        //  this.identifierValueLists[indexi]["bvdid"] = Object.assign({}, this.identifierLists);
        // console.info(this.identifierLists);
        // console.info(this.identifierValueLists[indexi]);
         // return this.identifierLists;
      }
    //console.info(' this.supplierDataLists',  this.supplierDataLists);
    
    },error=>{
      console.info('data_error', error); 
  });   

  //console.info("=======>",this.supplierDataLists);

  }

  customSearchFn(term: string, item:any) {
   // console.info('term', term, term.length);
    return  term &&  typeof term!='undefined' && item.allianceIdentifierSelect.toLocaleLowerCase().indexOf(term.toLocaleLowerCase()) > -1 && term.length>THREE;
  } 
  customSearchFn1(term: string, item:any) {
  //  console.info('term', term, term.length);
    return  term &&  typeof term!='undefined' && item.allianceIdentifierLegalname.toLocaleLowerCase().indexOf(term.toLocaleLowerCase()) > -1 && term.length>THREE;
  }

}